import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-player-block',
  templateUrl: './player-block.component.html',
  styleUrls: ['./player-block.component.scss']
})
export class PlayerBlockComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
